import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConnectedShopMovie, DataApiResponse, MovieLabel } from '@digilize/shared/definitions/src';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MovieLabelsApiService {
  constructor(private http: HttpClient) {}
  readonly BASE_URL = '/api/v1.0/movie-labels';

  getLabels(params?): Observable<DataApiResponse<MovieLabel[]>> {
    return this.http.get<DataApiResponse<MovieLabel[]>>(`${this.BASE_URL}`, { params });
  }

  getLabel(id: string): Observable<MovieLabel> {
    return this.http.get<MovieLabel>(`${this.BASE_URL}/${id}`);
  }

  addLabel(label: Partial<MovieLabel>): Observable<MovieLabel> {
    return this.http.post<MovieLabel>(`${this.BASE_URL}`, label);
  }

  editLabel(label: MovieLabel): Observable<MovieLabel> {
    return this.http.put<MovieLabel>(`${this.BASE_URL}/${label.id}`, label);
  }

  deleteLabel(id: string): Observable<void> {
    return this.http.delete<void>(`${this.BASE_URL}/${id}`);
  }

  getConnectedMovies(id: string, params?): Observable<DataApiResponse<ConnectedShopMovie[]>> {
    return this.http.get<DataApiResponse<ConnectedShopMovie[]>>(`${this.BASE_URL}/${id}/movies`, { params });
  }

  // DELETE with a body: HttpClient.delete supports it, but request() states the intent plainly.
  detachMovies(id: string, shopMovieIds: string[]): Observable<void> {
    return this.http.request<void>('delete', `${this.BASE_URL}/${id}/movies`, {
      body: { shop_movie_ids: shopMovieIds },
    });
  }
}
